import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Input } from '@/components/ui/input';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { createOrganizationSchema, type CreateOrganizationInput } from '../../schemas/organizationSchemas';

interface CreateOrganizationFormProps {
  onSubmit: (values: CreateOrganizationInput) => Promise<void>;
  formId?: string;
  onResetComplete?: () => void;
}

export function CreateOrganizationForm({ onSubmit, formId = 'create-organization-form', onResetComplete }: CreateOrganizationFormProps) {
  const form = useForm<CreateOrganizationInput>({
    resolver: zodResolver(createOrganizationSchema),
    defaultValues: {
      name: '',
    },
  });

  const handleSubmit = async (values: CreateOrganizationInput) => {
    try {
      await onSubmit(values);
      form.reset();
      onResetComplete?.();
    } catch (error) {
      // Error is handled by the parent component (e.g., via toast in the mutation)
      // We don't reset the form on error so user can correct and retry
    }
  };

  return (
    <Form {...form}>
      <form
        id={formId}
        className="space-y-4"
        onSubmit={form.handleSubmit(handleSubmit)}
        data-testid="organization-form"
      >
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Organization Name</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  placeholder="e.g., Starbucks"
                  data-testid="org-form-name"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
       
      </form>
    </Form>
  );
}